import { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import Translate from '../../i18n/Translate'
import { useTranslation } from 'react-i18next'
import { I18nContext } from '../../context/I18nProvider'
//Hook
// import useWindowWidth from '../../hooks/useWindowWidth'
//Components
import DestinationFilter from '../../components/Itinerary/DestinationFilter'
//Images
import tower_logo from '../../assets/images/tower_logo.svg'
import { ReactComponent as IconClose } from '../../assets/images/icons/close.svg'
import icon_filterlist from '../../assets/images/icons/material-filter-list.svg'

const FiltersMobile = () => {
    const { t } = useTranslation()
    // const windowWidth = useWindowWidth()
    const { language } = useContext(I18nContext)

    const [showFilters, setShowFilters] = useState(false)
    const [scrollY, setScrollY] = useState(0)

    useEffect(() => {
        if (showFilters) {
            document.body.style.overflowY = 'hidden'
            document.body.style.maxHeight = '100vh'
        } else {
            document.body.style.overflowY = ''
            document.body.style.maxHeight = ''
            window.scrollTo(0, scrollY) //Scrolleo hacia la posición original antes de abrir el panel
        }

        //Restauro el scroll al desmontar el componente
        return () => {
            document.body.style.overflowY = ''
            document.body.style.maxHeight = ''
        }
    }, [showFilters, scrollY])

    const handleOpenFilterPanel = (e) => {
        setShowFilters(true)
        setScrollY(window.scrollY)
    }

    const handleCloseFilterPanel = () => {
        setShowFilters(false)
    }

    return (
        <div className="filters-mobile">
            {/* BOTON Y PANEL SOLO PARA MOBILE Y TABLET */}
            <button className="filters-mobile__toogle-filter-btn" onClick={handleOpenFilterPanel}>
                <img src={icon_filterlist} alt="" />
                <Translate langkey="itinerary.filters_container_button" />
            </button>

            {/* FILTER PANEL */}
            {showFilters && (
                <div className="filters-mobile__filter-panel">
                    <header className="header">
                        <div className="logo">
                            <Link to={`/${language}${t('routes.home')}`}>
                                <img src={tower_logo} alt="tower-travel logo" />
                            </Link>
                        </div>

                        <div className="close-btn" onClick={handleCloseFilterPanel}>
                            <IconClose />
                        </div>
                    </header>

                    <div className="filter-wrapper">
                        <DestinationFilter handleCloseFilterPanel={handleCloseFilterPanel} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default FiltersMobile
